const baseURL = "PDApplication";

export const verifyPDPaymentUrl = (rrr) =>
	`${baseURL}/verify-payment?rrr=${rrr}`;
export const addOrUpdatePDProgrammeUrl = () =>
	`${baseURL}/add-or-update-pd-programme`;
export const addOrUpdatePDNextOfKinAndBasicInfoUrl = () =>
	`${baseURL}/add-or-update-pd-next-of-kin-and-basic-information`;
export const addOrUpdatePDEducationAndHonoursUrl = () =>
	`${baseURL}/add-or-update-pd-education-and-honours`;
export const addOrUpdatePDCertificateUrl = () =>
	`${baseURL}/add-or-update-pd-certificate`;
export const addOrUpdatePDEmploymentAndRefereeUrl = () =>
	`${baseURL}/add-or-update-pd-employment-and-referee`;
export const addOrUpdatePDLanguageAndOtherInfoUrl = () =>
	`${baseURL}/add-or-update-pd-language-and-other-information`;

export const getPDRefereeInfoUrl = (passCode) =>
	`${baseURL}/pd-referee-information?passCode=${passCode}`;
export const submitPDRefereeReviewUrl = () => `${baseURL}/pd-referee-review`;
export const getPDTrackingVerificationUrl = (rrr) =>
	`${baseURL}/reprint-pd-application?rrr=${rrr}`;
export const getPDTranscriptRequestUrl = (rrr) =>
	`${baseURL}/pd-transcript-request?rrr=${rrr}`;
export const getPDRefereePrintOutUrl = (refereeEmail, applicantId) =>
	`${baseURL}/pd-referee-printout?refereeEmail=${refereeEmail}&applicantId=${applicantId}`;
export const getPDRefereeStatusUrl = (rrr) =>
	`${baseURL}/pd-referee-status?rrr=${rrr}`;
export const updatePDRefereeUrl = (refereeId) =>
	`${baseURL}/update-pd-referee?refereeId=${refereeId}`;
